import { render, staticRenderFns } from "./InventarioTable.vue?vue&type=template&id=645631de&scoped=true&"
import script from "./InventarioTable.vue?vue&type=script&lang=js&"
export * from "./InventarioTable.vue?vue&type=script&lang=js&"
import style0 from "./InventarioTable.vue?vue&type=style&index=0&id=645631de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645631de",
  null
  
)

component.options.__file = "InventarioTable.vue"
export default component.exports